import React from 'react'
import I18n from 'components/I18n'
import IconSVG from 'svg-inline-react'
import { Link } from 'react-router'
import style from './style.styl'
import closeSrc from '!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/navigation/close.svg'


const CustomizeTemplate = ({ main, preview }) => (
  <div className={style.CustomizeTemplate}>
    <I18n className={style.CustomizeSidebar}>
      { main }
    </I18n>
    <div className="CustomizePreview">
      <Link to="/settings/widget">
        <IconSVG className="close-button" src={closeSrc}/>
      </Link>
      <I18n>
        { preview }
      </I18n>
    </div>
  </div>
)

export default CustomizeTemplate



// WEBPACK FOOTER //
// ./src/scripts/components/Customize/CustomizeTemplate/index.js